import { render, staticRenderFns } from "./RfxResponseTodoReplyViewer.vue?vue&type=template&id=1810d4f0"
import script from "./RfxResponseTodoReplyViewer.vue?vue&type=script&lang=js"
export * from "./RfxResponseTodoReplyViewer.vue?vue&type=script&lang=js"
import style0 from "./RfxResponseTodoReplyViewer.vue?vue&type=style&index=0&id=1810d4f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports